import { Component, Input } from '@angular/core';
import { PMFormatCompany } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-company-card',
  templateUrl: './circle-credit-company-card.component.html',
  styleUrls: ['./circle-credit-company-card.component.scss']
})
export class CircleCreditCompanyCardComponent {
  @Input() data: PMFormatCompany | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    return !!(this.data.companyName || this.data.rfc || this.data.firstName);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = ['rfc', 'companyName', 'firstName', 'address1', 'city', 'state', 'phone', 'email', 'clientType'];
    const filledFields = allFields.filter(field => this.data![field as keyof PMFormatCompany]);
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get representativeName(): string {
    if (!this.data) return 'No especificado';
    
    const parts = [
      this.data.firstName,
      this.data.middleName,
      this.data.lastNameFather,
      this.data.lastNameMother
    ].filter(part => part && part.trim());
    
    return parts.join(' ') || 'No especificado';
  }

  get fullAddress(): string {
    if (!this.data) return 'No especificado';
    
    const parts = [
      this.data.address1,
      this.data.address2,
      this.data.neighborhood,
      this.data.city,
      this.data.state,
      this.data.postalCode
    ].filter(part => part && part.trim());
    
    return parts.join(', ') || 'No especificado';
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) return 'No especificado';
    
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  }
}
